<template>
  <div>
    <table>
      <tr>
        <td>{{ placeholder }}</td>
        <td>
          <SwitchComponent
            v-model="_value"
            :checked="_value"
            style="padding-top: 10px"
            @change="onChange"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">
import { SwitchComponent } from "@syncfusion/ej2-vue-buttons";
import { ref, watch } from "vue";

interface Props {
  modelValue?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  placeholder: undefined,
  disabled: false,
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = defineEmits(["update:modelValue"]);

const _value = ref(false);

/*
onMounted(()=>{
  _value.value = props.modelValue

})
*/

watch(
  props,
  () => {
    _value.value = props.modelValue;
  },
  { immediate: true }
);

function onChange() {
  emit("update:modelValue", _value?.value);
}
</script>

<style scoped></style>
